import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import StandardError from 'components/common/standard_error'
import Modal from 'components/common/modal'
import { includes } from 'lodash'
import cssModules from 'react-css-modules'
import styles from './campaign_eligibility.less'
import { getI18n } from 'client/i18n'
import {
  NO_DESCRIPTION_ERRORS,
  DEXTER_SPECIFIC_ERRORS,
  CIP_ELIGIBILITY_CODES,
  CIP_ERROR_CODE,
} from 'shared/shared_consts'
import { trackImpression, trackClick } from 'lib/fpti_analytics'
import { getCIPStatus } from 'lib/create_campaign_eligibility'

const i18n = getI18n('components/common/campaign_eligibility')

class CampaignEligibility extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    CIPStatusCode: PropTypes.string,
    verificationFlow: PropTypes.string,
  }

  handleAnalyticsEvent(flow) {
    trackClick({
      clickName: 'account_overview',
      data: {
        flow: flow,
      },
    })
  }

  render() {
    let { CIPStatusCode, verificationFlow } = this.props
    let flow = includes(window.location.href, 'crowdfunding', false)
      ? 'GENEROSITY_NETWORK'
      : undefined
    let pageName, erpg, eccd
    if (CIPStatusCode === 'USER_REACHED_CAMPAIGN_CREATION_LIMIT') {
      pageName = 'create:duplicate_error'
      erpg = 'active_campaign_exists'
    } else if (includes(CIP_ERROR_CODE, CIPStatusCode, false)) {
      pageName = 'create:cip_error'
      eccd = 'Pass through CIP error'
    } else if (verificationFlow === 'RUGS') {
      pageName = 'create:rugs_error'
      eccd = 'Pass through RUGS error'
    } else {
      pageName = 'create:generic_error'
      eccd = `generic error: ${CIPStatusCode}`
    }

    trackImpression({
      pageName: pageName,
      flow: flow,
      erpg: erpg,
      eccd: eccd,
      event_name: 'dw_giving_failed_customer_interaction_occurred',
      event_type: 'ac',
      error_desc: CIPStatusCode,
      error_code: 200,
      screen: 'create_fundraiser',
    })
    CIPStatusCode =
      includes(DEXTER_SPECIFIC_ERRORS, CIPStatusCode) ||
      includes(CIP_ELIGIBILITY_CODES, CIPStatusCode)
        ? CIPStatusCode
        : 'ERROR'
    const title = i18n(`title.${CIPStatusCode}`)
    const description = includes(NO_DESCRIPTION_ERRORS, CIPStatusCode)
      ? ''
      : i18n(`description.${CIPStatusCode}`)
    return (
      <Modal animate={false} showClose={false}>
        <div styleName="eligibilty-errors">
          <StandardError
            iconType="warning"
            title={title}
            subtitle={description}
          />
          <a
            href="/myaccount/summary"
            onClick={() => this.handleAnalyticsEvent(flow)}
            className="vx_btn vx_btn-block vx_btn-secondary"
            styleName="go-to-account-button"
          >
            {i18n('go_to_account_button')}
          </a>
        </div>
      </Modal>
    )
  }
}
export default connect((state, ownProps) => {
  const campaignType = ownProps.route.campaignType
  const cipStatusObj =
    state.current_user.CIPEligibility &&
    state.current_user.CIPEligibility[campaignType]
  return {
    CIPStatus:
      cipStatusObj && getCIPStatus(campaignType, cipStatusObj, ownProps, state),
    CIPStatusCode: cipStatusObj && cipStatusObj.CIPStatusCode,
    verificationFlow: state.current_user.verificationFlow,
    ...ownProps,
  }
})(cssModules(CampaignEligibility, styles))
